import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useSelector } from 'store';
import ImageSlider from 'components/common/ImageSlider';
import Modal from 'components/common/Modal';
import Head from 'next/head';
import styled from 'styled-components';
import ModalRetailMap from './components/ModalRetailMap';

var RetailDetailService = function RetailDetailService() {
  var retail = useSelector(function (state) {
    return state.space.retail;
  });
  var branch = retail.floor.branch;
  var features = retail.features;

  var _useState = useState(false),
      isHoverOnMapIcon = _useState[0],
      setIsHoverOnMap = _useState[1];

  var kakao = branch.map_url_kakao;
  var google = branch.map_url_google;
  var naver = branch.map_url_naver;

  var _Modal = Modal(),
      openModal = _Modal.openModal,
      closeModal = _Modal.closeModal,
      ModalPortal = _Modal.ModalPortal;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(retail.name)
      }), /*#__PURE__*/_jsx("meta", {
        name: "application-name",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(retail.name)
      }), /*#__PURE__*/_jsx("meta", {
        name: "msapplication-tooltip",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(retail.name)
      }), /*#__PURE__*/_jsx("meta", {
        id: "meta_og_title",
        property: "og:title",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(retail.name)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "cnts-wrap",
      children: /*#__PURE__*/_jsxs("div", {
        className: "retail-detail",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "hgroup",
          children: [/*#__PURE__*/_jsx("span", {
            className: "logo",
            style: {
              backgroundImage: "url(".concat(retail.representation_image, ")")
            }
          }), /*#__PURE__*/_jsx("h2", {
            children: retail.name
          }), /*#__PURE__*/_jsx("address", {
            children: branch.address
          }), /*#__PURE__*/_jsxs("div", {
            className: "btn-map",
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: [/*#__PURE__*/_jsxs(OpenMapModalButton, {
              onClick: openModal,
              onPointerEnter: function onPointerEnter() {
                return setIsHoverOnMap(true);
              },
              onPointerLeave: function onPointerLeave() {
                return setIsHoverOnMap(false);
              },
              children: [/*#__PURE__*/_jsx("img", {
                src: isHoverOnMapIcon ? '/images/map-gray.svg' : '/images/map.svg',
                alt: "",
                style: {
                  width: 28,
                  height: 28
                }
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  color: isHoverOnMapIcon ? '#808080' : '#111',
                  marginLeft: 8
                },
                children: "\uC9C0\uB3C4 \uBCF4\uAE30"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: kakao,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uCE74\uCE74\uC624"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  margin: 6
                },
                children: "\xB7"
              }), /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: google,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uAD6C\uAE00"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  margin: 6
                },
                children: "\xB7"
              }), /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: naver,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uB124\uC774\uBC84"
                })
              })]
            })]
          })]
        }), retail.images.length ? /*#__PURE__*/_jsx(ImageSlider, {
          images: retail.images
        }) : null, /*#__PURE__*/_jsx("div", {
          className: "detail-cnts",
          children: /*#__PURE__*/_jsx("p", {
            style: {
              whiteSpace: 'pre-line'
            },
            children: retail.introduction
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "retail-info",
          children: [/*#__PURE__*/_jsxs("h3", {
            children: [retail.name, "\uC5D0\uC11C\uB294"]
          }), /*#__PURE__*/_jsx("ul", {
            children: features.map(function (feature, index) {
              return /*#__PURE__*/_jsx("li", {
                children: feature.description
              }, index);
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ModalPortal, {
      children: /*#__PURE__*/_jsx(ModalRetailMap, {
        closeModal: closeModal,
        branch: branch
      })
    })]
  });
};

var OpenMapModalButton = styled.div.withConfig({
  displayName: "_detail__OpenMapModalButton",
  componentId: "sc-1c373en-0"
})(["display:flex;align-items:center;justify-content:center;cursor:pointer;margin-right:8px;padding-right:8px;border-right:1px solid #111;"]);
var OpenMapPageAnchor = styled.a.withConfig({
  displayName: "_detail__OpenMapPageAnchor",
  componentId: "sc-1c373en-1"
})([":hover{color:#808080;}"]);
export default RetailDetailService;